
export const NewsMakerPluginSettings: IPluginSettings = {
    name: 'Новости',
    mnemocode: 'news_maker_plugin',
    permission: 'NewsMaker',
    columns: (() => {
        let index = 0;
        return [
            {
                order: index++,
                propertyName: 'idGlobal',
                propertyType: 'string',
                displayName: 'idGlobal',
                visibility: false,
                width: 300
            },
            {
                order: index++,
                propertyName: 'id',
                propertyType: 'number',
                displayName: 'id',
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'subject',
                propertyType: 'string',
                displayName: 'Заголовок',
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'description',
                propertyType: 'string',
                displayName: 'Новость',
                visibility: true,
                width: 350
            },
            {
                order: index++,
                propertyName: 'startDate',
                propertyType: 'datetime',
                displayName: 'Дата начала',
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'dueDate',
                propertyType: 'datetime',
                displayName: 'Дата окончания',
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'estimatedHour',
                propertyType: 'number',
                displayName: 'Расчетное время',
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'priority',
                propertyType: 'number',
                displayName: 'Приоритет',
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'dateCreated',
                propertyType: 'datetime',
                displayName: 'Дата создания',
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'dateModified',
                propertyType: 'datetime',
                displayName: 'Дата изменения',
                visibility: true,
                width: 150
            },
            {
                order: index++,
                propertyName: 'dateDeleted',
                propertyType: 'datetime',
                displayName: 'Дата удаления',
                visibility: true,
                width: 150
            },
        ]
        
    })()
};

    // readonly idGlobal: string;
    // readonly id: string;
    // readonly subject: string;
    // readonly description: string;
    // readonly startDate: string;
    // readonly dueDate: string;
    // readonly estimatedHour: number;
    // readonly priority: RedmineNewsPriority;
    // readonly isViewed: boolean;